import type { Formatter } from '../../core/types/formatter.js';
import type {
  InternalSliceData,
  InternalTooltipContent,
} from '../types/internal/pie-chart.js';

/**
 * Returns the pie tooltip content based on the slice details.
 * @param sliceId - id of the slice
 * @param data - slice data for the given slice
 * @param handlerCatch - catch error wrapper for formatting
 * @param formatter - formatter to be used
 * @returns The updated tooltip content object
 */

export const getTooltipContent = (
  sliceId: string,
  data: InternalSliceData,
  handlerCatch: (callback: unknown) => number,
  formatter: Formatter,
): InternalTooltipContent => {
  const formattedValue = handlerCatch(() => formatter(data.value, data.unit));
  const relativeValue = data.relativeValue.toFixed(2);

  return {
    id: sliceId,
    name: data.category,
    color: data.color.Default,
    absoluteValue: formattedValue,
    relativeValue: Number(relativeValue),
  };
};
